 import { Product } from "./product";
 import { PRODUCTS } from "../../products";
 import './shop.css'

 export const Shop = () => {
    return (
      <div className="shop">
        <div className="shopTitle">
          <h1>Tech Shop</h1>
        </div>
  
        <div className="products" style={{display: 'flex', flexWrap: 'wrap'}}>
          {PRODUCTS.map((product) => (
            <Product data={product} />
          ))}
        </div>
      </div>
    );
  };
